import axios from "axios";
import CryptoJS from "crypto-js";
import pako from "pako";
import {AdminAPIUrl} from "../../GlobalVar";
import {Encrypter} from "laravel-crypton";
import phpSerialize from "./phpSerialize";
import phpUnserialize from "./phpUnserialize";
import {store} from "../../store/store"


const key = "base64:gzMC8HMKHfXnKCzBOn0uZ+rw+e08QsRVIdeNZbEEZW4="
const rawKey = key.startsWith('base64:') ? key.substr(7) : key;
const EncrypterInst = new Encrypter(key);

function wordArrayToUint8Array(wordArray) {
    const {words, sigBytes} = wordArray;
    const u8 = new Uint8Array(sigBytes);
    for (let i = 0; i < sigBytes; i++) {
        u8[i] = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    }
    return u8;
}

// Mirrors EncrypterInst.decrypt(), but since the backend may now gzip-deflate
// the response body before encrypting it (same WAF-dodging trick used for
// requests in phpSerialize.js), we can't let Encrypter.decrypt() force a
// toString(Utf8) on the raw AES output - that throws "Malformed UTF-8 data"
// on compressed bytes. Try plain text first (uncompressed responses keep
// working unchanged), only inflate if that fails.
function decryptResponsePayload(payload) {
    const params = JSON.parse(atob(payload));
    const decryptedWords = CryptoJS.AES.decrypt(params.value, CryptoJS.enc.Base64.parse(rawKey), {
        iv: CryptoJS.enc.Base64.parse(params.iv)
    });

    let serialized;
    try {
        serialized = decryptedWords.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        serialized = pako.inflate(wordArrayToUint8Array(decryptedWords), {to: 'string'});
    }

    return phpUnserialize(serialized);
}

export const laravelAxios = axios.create({
    baseURL: AdminAPIUrl
})

laravelAxios.interceptors.response.use(function (response) {
    // console.log("check the response",response)
    return response;
}, function (error) {
    if (error.response?.data?.payload !== undefined) {
        error.response.data = decryptResponsePayload(error.response.data.payload);
    }
    return Promise.reject(error);
});

laravelAxios.interceptors.response.use(
    function (response) {
        // console.log("check the response",response)
        return response;
    },
    function (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.payload
        ) {
            error.response.data = EncrypterInst.decrypt(error.response.data.payload);
        }
        return Promise.reject(error);
    }
);

// Continue to update Authorization header on store changes
store.subscribe(() => {
    laravelAxios.defaults.headers.common['Authorization'] = `Bearer ${store.getState().user.authToken}`
});

// Replaces Crypton(key).both().encrypt(laravelAxios) with the same
// encrypt-request/decrypt-response contract, but gzip-compresses the
// serialized payload before encrypting it. Large carts otherwise produce
// a long enough AES ciphertext blob to trip the WAF's obfuscated-payload
// rule (see /draft CORS investigation) - compressing first keeps the
// ciphertext short. Guarded behind x-request-compressed so the backend
// can roll out gunzip support before this ships without breaking older
// clients still sending uncompressed encrypted payloads.
laravelAxios.interceptors.request.use((config) => {
    config.headers['x-request-encrypted'] = 1;
    config.headers['x-response-encrypted'] = 1;
    config.headers['x-request-compressed'] = 1;

    const serialized = phpSerialize(config.data);
    const compressed = pako.deflate(serialized); // zlib format -> pairs with PHP gzuncompress()
    const wordArray = CryptoJS.lib.WordArray.create(compressed);
    config.data = { payload: EncrypterInst.encrypt(wordArray, false) };

    return config;
}, (error) => Promise.reject(error));

laravelAxios.interceptors.response.use((response) => {
    if (response.config.headers['x-response-encrypted'] !== undefined && response.data?.payload !== undefined) {
        response.data = decryptResponsePayload(response.data.payload);
    }

    return response;
});
